import React from "react";
import Modal from "react-modal";
import { AxiosResponse } from "axios";

import { IMaster } from "app/api/types";
import AddMaster from "./components/AddMaster";

import Master from "./components/Master";
import BackButton from "app/features/BackButton";
import Loader from "app/components/Loader";

import "./styles.scss";

interface IProps {
  masterList: IMaster[];
  isLoading: boolean;
  addMaster: (data: IMaster) => Promise<AxiosResponse>;
  delMaster: (email: IMaster["email"]) => Promise<AxiosResponse>;
  editMaster: (data: IMaster) => Promise<AxiosResponse>;
  getMasters: () => Promise<AxiosResponse>;
}

interface IState {
  modalIsOpen: boolean;
  isSuccessActive: boolean;
  isSubmit: boolean;
}

Modal.setAppElement("#root");

class MasterList extends React.Component<IProps, IState> {
  state = {
    modalIsOpen: false,
    isSuccessActive: false,
    isSubmit: false,
  };

  openModal = () => {
    this.setState({ modalIsOpen: true });
  };

  closeModal = () => {
    this.setState({ modalIsOpen: false });
  };

  addMaster = (data: IMaster) => {
    this.props.addMaster(data).then(() => this.props.getMasters());
    this.setState({ isSubmit: false, isSuccessActive: false });
    this.closeModal();
  };

  editMaster = (data: IMaster) => {
    this.props.editMaster(data).then(() => this.props.getMasters());
  };

  delMaster = (email: IMaster["email"]) => {
    this.props.delMaster(email).then(() => this.props.getMasters());
  };

  onSuccessChange = (active: boolean) => {
    this.setState({ isSuccessActive: active });
  };

  render() {
    if (this.props.isLoading)
      return (
        <div className="loader-wrapper">
          <Loader />
        </div>
      );
    return (
      <div className="user-group">
        <Modal
          isOpen={this.state.modalIsOpen}
          onRequestClose={this.closeModal}
          contentLabel="Add phrase modal"
          className="user-group__modal"
          overlayClassName="user-group__overlay"
        >
          <button onClick={this.closeModal} className="modal-close" />
          <AddMaster
            onSubmit={this.addMaster}
            onSuccessChange={this.onSuccessChange}
            isSubmit={this.state.isSubmit}
          />
          {this.state.isSuccessActive && (
            <button
              onClick={() => this.setState({ isSubmit: true })}
              className="modal-success"
            />
          )}
        </Modal>

        <div className="user-group__header">
          <div className="header__back-button">
            <BackButton to="/" />
          </div>

          <div className="header__group-label">
            <p className="label__text">Мастера</p>
            <p className="label__counter">{this.props.masterList.length}</p>
            <button className="label__add-button" onClick={this.openModal} />
          </div>
        </div>

        <div className="user-group__content">
          <div className="column">
            {this.props.masterList.map((master) => (
              <Master
                master={master}
                onSubmit={this.editMaster}
                onDelete={this.delMaster}
                key={master.id}
              />
            ))}
          </div>
        </div>
      </div>
    );
  }
}

export default MasterList;
